import {combineReducers} from 'redux';
import {pipeline, pipelinePagination, pipelineError} from './pipelineReducer';
import {leads, leadsError} from './leadsReducer';
import {latestApprovals, latestApprovalsError} from './latestApprovalsReducer';
import {latestContracts, latestContractsError} from './latestContractsReducer';
import {portfolio, portfolioPagination, portfolioError} from './portfolioReducer';
import attachments from './attachmentReducer';
import chartDataType from './chartDataTypeReducer';
import contacts from './contactReducer';
import kpis from './kpisReducer';
import mtd from './mtdReducer';
import partner from './partnerReducer';
import requestedStipsInfo from './requestedStipsInfoReducer';
import modal from './modalReducer';
import submissionInfo from './submissionInfoReducer';
import submissionsType from './submissionsTypeReducer';
import user from './userReducer';
import uuid from './uuidReducer';
import { modelReducer, formReducer } from 'react-redux-form';
import headerNavToolbarItems from './headerNavToolbarItemsReducer';

const rootReducer = combineReducers({
  attachments,
  chartDataType,
  kpis,
  leads,
  leadsError,
  latestApprovals,
  latestApprovalsError,
  latestContracts,
  latestContractsError,
  modal,
  mtd,
  submission: modelReducer('submission'),
  submissionForm: formReducer('submission'),
  submissionInfo,
  pipeline,
  pipelineError,
  pipelinePagination,
  portfolio,
  portfolioError,
  portfolioPagination,
  submissionsType,
  user,
  partner,
  requestedStipsInfo,
  requestedStip: modelReducer('requestedStip'),
  requestedStipForm: formReducer('requestedStip'),
  contacts,
  uuid,
  headerNavToolbarItems
});

export default rootReducer;
